import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import Theme from '../styles/Theme';
import GlobalStyles from '../styles/Global';

// STYLES
const LayoutContainer = styled.div`
  max-width: ${props => props.theme.layout.width.container};
  margin: 0 auto;
`;

const Layout = props => (
  <ThemeProvider theme={ Theme }>
    <GlobalStyles />
    <LayoutContainer className="fadeIn">{ props.children }</LayoutContainer>
  </ThemeProvider>
);

export default Layout;